import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import 'hooper/dist/hooper.css';
import { S3_ASSETS_BUCKET_URL } from '../helpers/constants/LandingPage';
let GrabExpress = class GrabExpress extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin, UserAgentMixin) {
    get videoDimensions() {
        if (this.smAndDown) {
            return { width: 320, height: 250 };
        }
        return { width: 820, height: 520 };
    }
    goToBlog() {
        window.open('https://blog.chatgenie.ph/orders-coming-from-your-mini-app-can-now-be-delivered-by-grab-express/');
    }
    goToLandingPage() {
        window.open('https://chatgenie.ph');
    }
    get heroBanners() {
        return [
            'grab-express-hero-banner-1.png',
            'grab-express-hero-banner-2.png',
            'grab-express-hero-banner-3.png',
            'grab-express-hero-banner-4.png',
        ].map((img) => `${S3_ASSETS_BUCKET_URL}/${img}`);
    }
    get howItWorksBanners() {
        return [
            'grab-express-how-it-works-1.png',
            'grab-express-how-it-works-2.png',
            'grab-express-how-it-works-3.png',
            'grab-express-how-it-works-4.png',
            'grab-express-how-it-works-5.png',
        ].map((img) => `${S3_ASSETS_BUCKET_URL}/${img}`);
    }
    get howItWorksSections() {
        return [
            {
                description: `Customers can tap the “View Details” button to know 
                      the identity and contact information of the rider for security 
                      purposes.`,
                img: `${S3_ASSETS_BUCKET_URL}/grab-how-it-works-1.png`,
            },
            {
                description: `For impatient customers, they can track the status of 
                      their delivery by clicking the link to track the order.`,
                img: `${S3_ASSETS_BUCKET_URL}/grab-how-it-works-2.png`,
            },
            {
                description: `In case that the customer is busy while waiting for the 
                      rider to arrive, a notification will be sent to their Messenger 
                      account that the rider is already on its way.`,
                img: `${S3_ASSETS_BUCKET_URL}/grab-how-it-works-3.png`,
            },
            {
                description: `On the same Grab Express Delivery Tracking Page, customers will 
                      also see the photos of the ordered goods taken upon pick and drop off. 
                      This will help both Merchants and Customers to easily trace whose liable 
                      in case there’s something wrong with the ordered goods.`,
                img: `${S3_ASSETS_BUCKET_URL}/grab-how-it-works-4.png`,
            },
        ];
    }
};
GrabExpress = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: {
            Hooper,
            Slide,
            HooperPagination,
            TheFooter,
            GetStarted,
        },
    })
], GrabExpress);
export default GrabExpress;
